import React, { useEffect, useState } from 'react'
import AdminBreadcrumb from '../Common/AdminBreadcrumb';
import Editor from '../Common/Editor';

import { CreatePages, GetPages, DetailPages } from '../../../API/admin'
import { useNavigate, useLocation } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import {
    CCard,
    CCardBody,
    CTable,
    CTableDataCell,
    CTableHeaderCell,
    CTableBody,
    CTableHead,
    CTableRow,

} from '@coreui/react';

const CreateContentPage = () => {
    // Manage AdminBreadcrumb
    const adminBreadcrumbLinks = [
        { label: 'Dashboard', to: '/admin/dashboard', active: false },
        { label: 'Content Management', to: '/content_manage', active: false },
        { label: 'Edit', to: '', active: true }
    ];

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [Type, setType] = useState(null);
    const [DisableRegister, setDisableRegister] = useState(false);
    const [errors, setErrors] = useState({});
    const [CriteriaShow, setCriteriaShow] = useState(false);
    const [FormData, setFormData] = useState({
        page_name: '',
        page_body: '',
        id: ''
    })

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        var type = urlParams.get('type')
        setType(type)
        var urlid = {
            data: urlParams.get('id')
        }
        let callAPI = async () => {

            let res = await DetailPages(urlid);
            console.log(res)
            if (res.status) {
                setFormData(res.data);
            }
        }
        if (urlid) {
            callAPI();
        }
    }, [])

    const HandelChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    const handleEditorChange = (content) => {
        setFormData(prevState => ({
            ...prevState,
            page_body: content
        }));
    };
    const HandelSubmit = async (event) => {
        event.preventDefault();
        console.log(FormData)
        let res = await CreatePages(FormData)
        if (res.data.status) {
            enqueueSnackbar('Content saved successfully', {
                variant: 'success', action: (key) => (
                    <button className='toast_close_btn'
                        onClick={() => {
                            // Close the Snackbar
                            closeSnackbar(key);
                        }}
                    >
                        X
                    </button>
                ),
            });
            navigate('/content_management');
        }
        else {
            // swal("Oops!", res.data.message, "error");
            enqueueSnackbar('Unable to save content', {
                variant: 'error', action: (key) => (
                    <button className='toast_close_btn'
                        onClick={() => {
                            // Close the Snackbar
                            closeSnackbar(key);
                        }}
                    >
                        X
                    </button>
                ),
            });
            navigate('/content_management');

            // swal("Oops!", res.data.message, "error");
        }

    }




    return (
        <>
            <h4 className="card-title mb-3 align-items-center">
                Content Managment
            </h4>
            <AdminBreadcrumb links={adminBreadcrumbLinks} />

            <CCard className="mb-4">
                <CCardBody>
                    <div className="row justify-content-center">
                        <div className="col-md-7">
                            <form onSubmit={HandelSubmit}>
                                <div className='row mb-4'>
                                    <div className="col-12">
                                        <label htmlFor="exampleInputEmail1" className="form-label">
                                            Page Name
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name='page_name'
                                            onChange={HandelChange}
                                            value={FormData.page_name}
                                            readOnly
                                        />

                                        <input type="hidden" value={FormData.id} name='id' />
                                    </div>
                                    <div className="col-12">

                                        <label htmlFor="exampleInputEmail1" className="form-label">
                                            Page Body

                                        </label>
                                        <Editor name='page_body' dataValue={FormData.page_body} onChange={(content) => handleEditorChange(content)}></Editor>

                                    </div>
                                </div>
                                <button type="button" className="btn btn-secondary mx-3  float-end" onClick={() => window.history.back()}>
                                    Cancel
                                </button>
                                <button type="submit" className="btn btn-primary float-end" >
                                    Submit
                                </button>
                            </form>
                        </div>
                    </div>
                </CCardBody>
            </CCard>
        </>
    )
}
export default CreateContentPage;